import type { TooltipProps } from 'recharts';
import { MUTED } from './chuva-chart-constants';
import { formatMm } from './chuva-chart-utils';

const ChuvaTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (!active || !payload?.length) return null;
  const item = payload[0];
  const name =
    (item.payload as { name?: string } | undefined)?.name ?? item.name;
  return (
    <div className="rv-chuva-tooltip">
      <div className="rv-chuva-tooltip-name">{name}</div>
      <div
        className="rv-chuva-tooltip-value"
        style={{ color: item.color ?? MUTED }}
      >
        {formatMm(typeof item.value === 'number' ? item.value : null)}
      </div>
    </div>
  );
};

export default ChuvaTooltip;
